// window.FirebasePlugin.getToken(token => console.log(`token: ${token}`))
const FirebasePlugin = window.FirebasePlugin;

let getToken = function() {
  FirebasePlugin.getToken(
    function(token) {
      localStorage.setItem("fcm_token", token);
      // log("Got FCM token: " + token)
    },
    function() {
      // logError("Failed to get FCM token", error);
    }
  );
};

let checkNotificationPermission = function(requested) {
  if (!FirebasePlugin) return;
  FirebasePlugin.hasPermission(function(hasPermission) {
    if (hasPermission) {
      //log("Remote notifications permission granted");
      // Granted
      getToken();
    } else if (!requested) {
      // Request permission
      //log("Requesting remote notifications permission");
      FirebasePlugin.grantPermission(
        checkNotificationPermission.bind(this, true)
      );
    } else {
      // Denied
      //logError("Notifications won't be shown as permission is denied");
    }
  });
};

checkNotificationPermission(false);

export default window.FirebasePlugin;
